import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Product/BoxCounter/boxCounter.container"
    ).then((module) => ({ default: module.BoxCounterContainer }))
);
